<template>
<div class="application">
  <div class="application-img">
    <img :src="applicationImg" alt="">
  </div>
  <div class="application-point">接单成功!</div>
  <div class="my-person">
    <van-button type="info" class="person"  @click="toPerson">立即进行签约</van-button>
  </div>

</div>
  
</template>
<script>
export default {
  data(){
    return{
      applicationImg:require("../../../assets/img/taskSuccess.png")

    }
  }  ,
  methods:{
    toPerson(){
      this.$router.push({path:"/updateInfo"})
    }
  }
}
</script>
<style lang="less">
.application{
  width: 100%;
  padding: 200px 0;
  .application-img{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
  }
  .application-point{
    text-align: center;
    font-size: 32px;
  }
  .my-person{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 80px;
    .person{
      width: 90%;
      border-radius: 45px;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/task/applicationSuccess/index.vue